<template>
    <div v-if="!user" class="ecommerce-landing-page">
        <Intro/>
        <Customers/>
        <JoinNow/>
        <HowItWork/>
        <JoinedShops/>
        <UsersOpinion/>
        <Strategy/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Intro from './Intro'
import Customers from './Customers'
import JoinNow from './JoinNow'
import UsersOpinion from './UsersOpinion'
import Strategy from './Strategy/index.vue'
import HowItWork from './HowItWork/index.vue'
import JoinedShops from './JoinedShops/index.vue'
export default {
    name: 'LandingPageEcommerce',
    components: {
        Intro,
        Customers,
        JoinNow,
        UsersOpinion,
        Strategy,
        HowItWork,
        JoinedShops
    },
    computed: {
        ...mapState(['user'])
    },
    mounted() {
        if(this.user) {
            this.$router.push('/browse').catch(() => {})
        }
    }
}
</script>

<style>

</style>